module.exports = __webpack_public_path__ + "static/media/fireflyWorld1.a26384a0.png";